import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

// Pages load on first visit, so the app starts fast.
const OverviewPage = lazy(() => import("./web/OverviewPage.js").then((m) => ({ default: m.OverviewPage })));
const RatesPage = lazy(() => import("./web/RatesPage.js").then((m) => ({ default: m.RatesPage })));
const StatementPage = lazy(() => import("./web/StatementsPage.js").then((m) => ({ default: m.StatementPage })));
const StatementsPage = lazy(() => import("./web/StatementsPage.js").then((m) => ({ default: m.StatementsPage })));

export default defineWebModule({
  manifest,
  pages: { "": OverviewPage, "/rates": RatesPage, "/statements": StatementsPage, "/statement": StatementPage },
});
